import React, { useContext } from 'react'
import { TextField } from '@strata-monorepo/shared-ui/components/TextField/TextField'
import { type FormStepProps, OdysseyContext } from '@redventures/odyssey'

interface TextQuestionComponentProps {
  title: string
  subtitle?: string
  formValue: string
  textCollection: TextQuestionItem[]
}

interface TextQuestionItem {
  formValue: string
  type: string
  label: string
  placeholder: string
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>
}

const TextQuestion: React.FC<FormStepProps> = ({ formStep }) => {
  const { componentProps } = formStep
  const { textCollection } = componentProps as TextQuestionComponentProps

  const odysseyContext = useContext(OdysseyContext)

  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    item: TextQuestionItem,
  ) => {
    odysseyContext?.setValue(item.formValue, event.target.value)
  }

  return (
    <div>
      <div className='strata:mt-3 strata:mb-1'>
        {textCollection.map((item) => {
          const IconComponent = item.icon
          return (
            <TextField
              key={item.formValue}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleInputChange(e, item)}
              label={item.label}
              placeholder={item.placeholder}
              icon={<IconComponent className='strata:h-3 strata:w-3' />}
              error={odysseyContext?.getError(item.formValue)}
            />
          )
        })}
      </div>
    </div>
  )
}

export default TextQuestion
